import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import ScreenQuery from './__generated__/ScreenQuery.graphql.ts';

export function preloadScreen(spaceKey) {
	return query({
		query: ScreenQuery,
		variables: {
			spaceKey,
		},
	});
}
